import React from "react";
import { ArrowLeft } from "lucide-react";
import { BagLogo } from "../components/Logo";

const S = ({ n, title, children }) => (
  <section className="mt-6" data-testid={`privacy-section-${n}`}>
    <h2 className="font-display font-black text-lg text-slate-900">{n}. {title}</h2>
    <div className="mt-2 space-y-2 text-sm text-slate-600 leading-relaxed whitespace-pre-line">{children}</div>
  </section>
);

export default function LegalPrivacy() {
  return (
    <div className="min-h-screen bg-[#F9F9F7]">
      <div className="max-w-2xl mx-auto bg-white min-h-screen shadow-2xl px-6 py-8" data-testid="privacy-page">
        <div className="flex items-center gap-3">
          <button data-testid="legal-back" onClick={() => (window.history.length > 1 ? window.history.back() : window.location.assign("/"))} className="bg-slate-100 rounded-full p-2 active:scale-95 transition-transform"><ArrowLeft size={18} /></button>
          <a href="/" className="flex items-center gap-2 text-brand-red font-display font-bold"><BagLogo size={28} /> Ponesi</a>
        </div>
        <h1 className="font-display font-black text-2xl sm:text-3xl text-slate-900 mt-5">Politika privatnosti platforme Ponesi</h1>
        <p className="text-xs text-slate-400 mt-1">Verzija 1.0</p>

        <S n="1" title="RUKOVALAC PODACIMA">{`Rukovalac podacima o ličnosti u okviru platforme Ponesi je:

Sahara Group DOO
Masarikov Trg 18
16000 Leskovac, Republika Srbija
PIB: 115572837
Matični broj: 22177460

Kontakt za pitanja u vezi sa privatnošću:
privacy@ponesi.rs`}</S>

        <S n="2" title="O POLITICI PRIVATNOSTI">{`Ova Politika privatnosti objašnjava koje podatke Ponesi može obrađivati, u koje svrhe, po kom osnovu i koja prava imaju korisnici.

Ponesi nastoji da podatke obrađuje zakonito, pošteno, transparentno i samo u meri potrebnoj za određenu svrhu.`}</S>

        <S n="3" title="PODACI KOJE MOŽEMO OBRAĐIVATI">{`U zavisnosti od načina korišćenja Platforme možemo obrađivati:

Podatke o korisničkom nalogu:
- ime i prezime;
- email adresu;
- korisnički identifikator;
- podatke potrebne za autentifikaciju;
- profilnu fotografiju ako je dostupna preko izabranog sistema prijave.

Kontakt podatke:
- broj telefona kada je potreban radi realizacije porudžbine ili komunikacije.

Podatke o porudžbinama:
- restoran;
- proizvode;
- opcije;
- količine;
- cenu;
- vreme kreiranja;
- vreme preuzimanja;
- status porudžbine;
- istoriju relevantnih promena;
- javni broj porudžbine.

Podatke o verifikaciji:
- email adresu;
- informaciju da li je email verifikovan;
- vreme uspešne verifikacije.

Ponesi ne mora čuvati sadržaj jednokratnog OTP koda kada proveru vrši eksterni servis.

Podatke o lokaciji:
Ako korisnik odobri lokaciju, Ponesi može koristiti trenutnu lokaciju kako bi prikazao restorane u blizini.
Ponesi ne koristi ovu funkciju za kontinuirano praćenje lokacije korisnika.

Tehničke podatke:
Možemo obrađivati određene tehničke podatke koji nastaju korišćenjem Platforme, kao što su IP adresa, informacije o uređaju i pregledaču, tehnički logovi, bezbednosni događaji i informacije o greškama, kada je to potrebno za bezbednost, dijagnostiku i funkcionisanje sistema.

Podatke komunikacije:
Informacije koje nam korisnik dostavi kada kontaktira podršku ili Sahara Group DOO.`}</S>

        <S n="4" title="SVRHE OBRADE">{`Podatke možemo obrađivati radi:
- kreiranja i upravljanja nalogom;
- autentifikacije korisnika;
- verifikacije email adrese;
- kreiranja i obrade porudžbine;
- prosleđivanja porudžbine izabranom restoranu;
- prikazivanja statusa porudžbine;
- omogućavanja preuzimanja;
- pružanja korisničke podrške;
- rešavanja reklamacija;
- održavanja bezbednosti sistema;
- sprečavanja zloupotreba i prevara;
- ispunjavanja zakonskih obaveza;
- poboljšavanja stabilnosti i funkcionisanja Platforme.`}</S>

        <S n="5" title="PRAVNI OSNOV">{`Pravni osnov zavisi od konkretne svrhe.

Obrada može biti zasnovana na:
- izvršenju ugovora ili preduzimanju radnji na zahtev korisnika;
- ispunjavanju zakonske obaveze;
- legitimnom interesu Sahara Group DOO kada nad tim interesom ne pretežu prava korisnika;
- pristanku korisnika kada je pristanak odgovarajući pravni osnov.

Prihvatanje Politike privatnosti ne predstavlja opšti pristanak na svaku obradu podataka.`}</S>

        <S n="6" title="GOOGLE PRIJAVA">{`Ako korisnik koristi Google prijavu, Ponesi može dobiti određene podatke od Google-a, kao što su:
- email;
- ime;
- korisnički identifikator;
- profilna fotografija ako je dostupna.

Tačan obim podataka zavisi od konfiguracije prijave i dozvola.`}</S>

        <S n="7" title="EMAIL VERIFIKACIJA">{`Ponesi može koristiti eksternog pružaoca usluga radi slanja i potvrđivanja email verifikacionog koda.

To trenutno može uključivati Twilio Verify i SendGrid.

Nakon uspešne verifikacije Ponesi može sačuvati:
- informaciju da je email verifikovan;
- vreme verifikacije.`}</S>

        <S n="8" title="PODACI KOJI SE DOSTAVLJAJU RESTORANU">{`Kada korisnik kreira porudžbinu, izabranom restoranu dostavljaju se podaci potrebni za realizaciju porudžbine.

To može uključivati:
- javni broj porudžbine;
- proizvode i opcije;
- količine;
- vreme preuzimanja;
- napomene korisnika;
- kontakt podatke kada su potrebni za realizaciju porudžbine.

Restoran ne treba da dobije podatke koji nisu potrebni za izvršenje porudžbine.`}</S>

        <S n="9" title="PRUŽAOCI TEHNIČKIH USLUGA">{`Ponesi može koristiti spoljne pružaoce usluga radi funkcionisanja Platforme.

To može uključivati, u zavisnosti od aktuelne tehničke arhitekture:
- Supabase;
- Google;
- Twilio;
- SendGrid;
- hosting i infrastrukturne pružaoce;
- sisteme za monitoring i bezbednost.`}</S>

        <S n="10" title="PRENOS PODATAKA VAN SRBIJE">{`Neki pružaoci usluga mogu obrađivati podatke van Republike Srbije.

Kada takva obrada predstavlja međunarodni prenos podataka o ličnosti, Sahara Group DOO preduzima odgovarajuće mere radi zakonitosti takvog prenosa.`}</S>

        <S n="11" title="ČUVANJE PODATAKA">{`Podaci se čuvaju onoliko dugo koliko je potrebno za svrhu zbog koje su prikupljeni ili koliko je potrebno radi zakonskih obaveza, rešavanja sporova ili zaštite pravnih interesa.

Podaci korisničkog naloga mogu se čuvati dok korisnički nalog postoji.

Podaci o porudžbinama mogu se čuvati i nakon izvršenja porudžbine radi istorije porudžbina, reklamacija, računovodstvenih ili drugih zakonskih obaveza i ostvarivanja ili odbrane pravnih zahteva.

Tehnički i bezbednosni logovi čuvaju se samo u periodu koji je razumno potreban za bezbednost i dijagnostiku, osim ako postoji razlog za njihovo duže čuvanje.`}</S>

        <S n="12" title="LOKACIJA">{`Ponesi može zatražiti dozvolu za pristup trenutnoj lokaciji korisnika radi prikazivanja najbližih restorana.

Korisnik može odbiti dozvolu.

Odbijanje dozvole za lokaciju ne sprečava osnovno korišćenje Platforme.

Ponesi ne koristi lokaciju za kontinuirano praćenje kretanja korisnika.`}</S>

        <S n="13" title="KOLAČIĆI I LOCAL STORAGE">{`Ponesi može koristiti neophodne kolačiće, localStorage ili slične tehnologije radi:
- prijave;
- bezbednosti;
- čuvanja korpe;
- izbora jezika;
- korisničkih podešavanja;
- tehničkog funkcionisanja Platforme.

Ako Ponesi uvede analitičke, marketinške ili druge neobavezne tehnologije za koje je potrebna saglasnost, korisniku treba omogućiti odgovarajući izbor pre njihovog aktiviranja.`}</S>

        <S n="14" title="MARKETING">{`Saglasnost za marketing nije uslov za korišćenje Ponesi-ja.

Ako korisniku bude ponuđena mogućnost primanja marketinških poruka, saglasnost mora biti:
- posebna;
- opciona;
- jasno formulisana;
- neoznačena unapred.

Korisnik može povući saglasnost za marketing bez gubitka mogućnosti korišćenja Platforme.`}</S>

        <S n="15" title="BEZBEDNOST">{`Ponesi primenjuje razumne tehničke i organizacione mere radi zaštite podataka od:
- neovlašćenog pristupa;
- neovlašćene izmene;
- gubitka;
- zloupotrebe;
- nezakonitog otkrivanja.

Nijedan informacioni sistem ne može garantovati apsolutnu bezbednost.`}</S>

        <S n="16" title="PRAVA KORISNIKA">{`U skladu sa važećim propisima i kada su za to ispunjeni uslovi, korisnik može imati pravo na:
- pristup svojim podacima;
- ispravku netačnih podataka;
- brisanje;
- ograničenje obrade;
- prenosivost;
- prigovor na obradu;
- povlačenje pristanka kada se obrada zasniva na pristanku.

Zahtev se može poslati na:
privacy@ponesi.rs

Korisnik takođe ima pravo da se obrati Povereniku za informacije od javnog značaja i zaštitu podataka o ličnosti.`}</S>

        <S n="17" title="BRISANJE NALOGA">{`Korisnik može zahtevati brisanje svog korisničkog naloga.

Brisanje naloga ne mora značiti trenutno brisanje svakog podatka ako postoji zakonski osnov ili obaveza da se određeni podaci nastave čuvati.

Podaci za koje više ne postoji svrha niti pravni osnov za obradu treba da budu obrisani ili anonimizovani.`}</S>

        <S n="18" title="MALOLETNA LICA">{`Ponesi nije namenjen tome da lica bez potrebne poslovne sposobnosti samostalno zaključuju pravne poslove za koje je potrebna saglasnost roditelja ili zakonskog zastupnika.

Maloletna lica treba da koriste Platformu uz odgovarajući nadzor roditelja ili zakonskog zastupnika.`}</S>

        <S n="19" title="IZMENE POLITIKE PRIVATNOSTI">{`Ponesi može menjati ovu Politiku privatnosti.

Aktuelna verzija i datum poslednje izmene biće dostupni na Platformi.

Ako izmena značajno utiče na način obrade podataka, korisnicima će biti pružena odgovarajuća informacija.`}</S>

        <S n="20" title="KONTAKT">{`Za sva pitanja u vezi sa privatnošću:

Sahara Group DOO
Masarikov Trg 18
16000 Leskovac, Republika Srbija
PIB: 115572837
MB: 22177460
Email:
privacy@ponesi.rs`}</S>

        <div className="mt-10 flex gap-3 text-sm">
          <a href="/uslovi-koriscenja" className="text-brand-red font-semibold underline" data-testid="link-to-terms">Uslovi korišćenja</a>
          <a href="/" className="text-slate-500 font-semibold">Nazad na Ponesi</a>
        </div>
      </div>
    </div>
  );
}
